import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import PauseCircleIcon from '@mui/icons-material/PauseCircle';
import RecommendIcon from '@mui/icons-material/Recommend';
import WatchLaterSharpIcon from '@mui/icons-material/WatchLaterSharp';
import React from 'react';

const Declined = ({ backgroundColor, testId }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        data-testid={testId ? testId : 'DeclinedIcon'}
      >
        <path
          d="M12 22C13.9778 22 15.9112 21.4135 17.5557 20.3147C19.2002 19.2159 20.4819 17.6541 21.2388 15.8268C21.9957 13.9996 22.1937 11.9889 21.8078 10.0491C21.422 8.10929 20.4696 6.32746 19.0711 4.92893C17.6725 3.53041 15.8907 2.578 13.9509 2.19215C12.0111 1.80629 10.0004 2.00433 8.17316 2.7612C6.3459 3.51808 4.78411 4.79981 3.6853 6.4443C2.58649 8.08879 2 10.0222 2 12C2 13.3132 2.25865 14.6136 2.7612 15.8268C3.26375 17.0401 4.00034 18.1425 4.92893 19.0711C5.85751 19.9997 6.9599 20.7362 8.17316 21.2388C9.38642 21.7413 10.6868 22 12 22ZM6 12.2C5.98443 12.0272 6.01916 11.8535 6.1 11.7L8.2 6.8C8.30951 6.55019 8.49265 6.33975 8.72495 6.1968C8.95725 6.05385 9.22764 5.98519 9.5 6H15C15.5304 6 16.0391 6.21071 16.4142 6.58579C16.7893 6.96086 17 7.46957 17 8V13C17.01 13.1857 16.9794 13.3714 16.9103 13.5441C16.8412 13.7168 16.7353 13.8724 16.6 14L12 19L11.31 18.31C11.1283 18.1208 11.0217 17.872 11.01 17.61V17.41L11.59 14H7C6.73478 14 6.48042 13.8946 6.29289 13.7071C6.10535 13.5196 6 13.2652 6 13V12.2Z"
          fill={backgroundColor}
        />
      </svg>
    </svg>
  );
};

const InProcess = ({ backgroundColor, color }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="InProcessIcon"
    >
      <circle cx="7" cy="7" r="7" fill={backgroundColor} />
      <path
        d="M3.21954 9.72099C2.92682 10.0137 2.92682 10.4877 3.21954 10.7805C3.3659 10.9268 3.55771 10.9998 3.74952 10.9998C3.94134 10.9998 4.13315 10.9268 4.27951 10.7805L6.73963 8.32035L5.67965 7.26087L3.21954 9.72099ZM9.36808 5.16141L10.4385 4.60744L11 3.52299L10.477 3L9.39256 3.56146L8.83859 4.63192L7.53386 5.93666L8.06335 6.46614L9.36808 5.16141ZM9.60235 8.00515C9.56839 8.00315 9.53592 7.99516 9.50145 7.99516C9.31863 7.99516 9.1453 8.03262 8.98345 8.09257L5.90743 5.01655C5.96738 4.8547 6.00484 4.68137 6.00484 4.49855C6.00484 4.46408 5.99685 4.43161 5.99485 4.39765C5.9419 3.6179 5.29952 3 4.50629 3C4.27551 3 4.05922 3.05645 3.86391 3.14985L4.85945 4.14539C4.9119 4.19784 4.94786 4.25978 4.97184 4.32522C5.03728 4.50254 5.00181 4.70884 4.85945 4.85171C4.76204 4.94911 4.63417 4.99806 4.50629 4.99806C4.44735 4.99806 4.3889 4.98508 4.33296 4.9641C4.26752 4.93962 4.20558 4.90416 4.15313 4.85171L3.1576 3.85617C3.06419 4.05148 3.00774 4.26777 3.00774 4.49855C3.00774 5.29178 3.62564 5.93416 4.40539 5.98711C4.43936 5.9891 4.47182 5.9971 4.50629 5.9971C4.68911 5.9971 4.86245 5.95963 5.02429 5.89969L8.10031 8.97571C8.04037 9.13755 8.0029 9.31089 8.0029 9.49371C8.0029 9.52818 8.0109 9.56064 8.01289 9.59461C8.06584 10.3744 8.70822 10.9923 9.50145 10.9923C9.73223 10.9923 9.94852 10.9358 10.1438 10.8424L9.14829 9.84687C9.09585 9.79442 9.05988 9.73248 9.0359 9.66704C8.97047 9.48971 9.00593 9.28341 9.14829 9.14055C9.2457 9.04315 9.37358 8.99419 9.50145 8.99419C9.5604 8.99419 9.61884 9.00718 9.67478 9.02816C9.74022 9.05264 9.80216 9.0881 9.85461 9.14055L10.8501 10.1361C10.9436 9.94078 11 9.72449 11 9.49371C11 8.70048 10.3821 8.0581 9.60235 8.00515Z"
        fill={color}
      />
    </svg>
  );
};

const InTransit = ({ backgroundColor, color }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="InTransitIcon"
    >
      <circle cx="7.5" cy="8" r="7.5" fill={backgroundColor} />
      <path
        d="M10.9602 4.255C10.8602 3.96 10.5802 3.75 10.2502 3.75H4.75024C4.42024 3.75 4.14524 3.96 4.04024 4.255L3.00024 7.25V11.25C3.00024 11.525 3.22524 11.75 3.50024 11.75H4.00024C4.27524 11.75 4.50024 11.525 4.50024 11.25V10.75H10.5002V11.25C10.5002 11.525 10.7252 11.75 11.0002 11.75H11.5002C11.7752 11.75 12.0002 11.525 12.0002 11.25V7.25L10.9602 4.255ZM4.75024 9.25C4.33524 9.25 4.00024 8.915 4.00024 8.5C4.00024 8.085 4.33524 7.75 4.75024 7.75C5.16524 7.75 5.50024 8.085 5.50024 8.5C5.50024 8.915 5.16524 9.25 4.75024 9.25ZM10.2502 9.25C9.83524 9.25 9.50024 8.915 9.50024 8.5C9.50024 8.085 9.83524 7.75 10.2502 7.75C10.6652 7.75 11.0002 8.085 11.0002 8.5C11.0002 8.915 10.6652 9.25 10.2502 9.25ZM4.00024 6.75L4.75024 4.5H10.2502L11.0002 6.75H4.00024Z"
        fill={color}
      />
    </svg>
  );
};

const Arrived = ({ backgroundColor, color }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="ArrivedIcon"
    >
      <circle cx="7.5" cy="8" r="7.5" fill={backgroundColor} />
      <path
        d="M7.5 2.5C9.43 2.5 11 4.07 11 6C11 8.625 7.5 12.5 7.5 12.5C7.5 12.5 4 8.625 4 6C4 4.07 5.57 2.5 7.5 2.5ZM6.735 8.5L10 5.205L9.3 4.5L6.735 7.09L5.7 6.045L5 6.75L6.735 8.5Z"
        fill={color}
      />
    </svg>
  );
};

export const PendingApprovalIcon = ({ color, size }) => {
  return (
    <WatchLaterSharpIcon
      data-testid="PendingIcon"
      sx={{ color }}
      fontSize={size}
    />
  );
};

export const PauseIcon = ({ color, size }) => {
  return (
    <PauseCircleIcon data-testid="PausedIcon" sx={{ color }} fontSize={size} />
  );
};

export const ApprovedIcon = ({ color, size }) => {
  return (
    <RecommendIcon data-testid="ApprovedIcon" sx={{ color }} fontSize={size} />
  );
};

export const InTransitIcon = ({ backgroundColor, color, size }) => {
  return <InTransit backgroundColor={backgroundColor} color={color} />;
};

export const CanceledIcon = ({ color, size }) => {
  return (
    <HighlightOffIcon
      data-testid="CanceledIcon"
      sx={{ color }}
      fontSize={size}
    />
  );
};

export const InProcessIcon = ({ backgroundColor, color, size }) => {
  return <InProcess backgroundColor={backgroundColor} color={color} />;
};

export const DoneIcon = ({ color, size }) => {
  return (
    <CheckCircleIcon data-testid="DoneIcon" sx={{ color }} fontSize={size} />
  );
};

export const DeclinedIcon = ({ backgroundColor, color, testId }) => {
  return (
    <Declined testId={testId} backgroundColor={backgroundColor} color={color} />
  );
};

export const ArrivedIcon = ({ backgroundColor, color }) => {
  return <Arrived backgroundColor={backgroundColor} color={color} />;
};
